import { DatabasesDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { DatabasesGraphQLResourceQuery } from '../../catalog/fetchers/DatabasesGraphQLResourceQuery';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { DeleteDatabasesRequest } from '../ServerApi/requests/DeleteDatabasesRequest';
import { GetDatabaseActionsRequest } from '../ServerApi/requests/GetDatabaseActionsRequest';
import { IDatabaseCertificationParams, SetDatabaseCertificationRequest } from '../ServerApi/requests/SetDatabaseCertificationRequest';
import { DisableDatabaseControlledPermissionsRequest, EnableDatabaseControlledPermissionsRequest } from '../ServerApi/requests/SetDatabaseControlledPermissionsRequest';
import { IDatabaseDescriptionParams, SetDatabaseDescriptionRequest } from '../ServerApi/requests/SetDatabaseDescriptionRequest';
import { IDatabaseContactParams, SetDatabasesContactRequest } from '../ServerApi/requests/SetDatabasesContactRequest';
import { DatabaseAllowedActions } from '../ServerApi/types/DatabaseAllowedActions';
import { IActionResult } from '../ServerApi/types/IActionResult';
import { IEmptyResult, IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { ServerService } from '../services/ServerService';
import { ToasterService, ToastType } from '../services/ToasterService';
import { IActionResource, IListResource } from './Resource';

export class Databases implements IActionResource<DatabaseAllowedActions>, IListResource<DatabasesDisplayGridRowData> {

  public static $inject = [
    '$q',
    'ErrorNotifyingServer',
    'ToasterService',
  ];

  private server: ServerService;
  private allQuery: DatabasesGraphQLResourceQuery;

  constructor(
    private $q: ng.IQService,
    private ErrorNotifyingServer: ErrorNotifyingServer,
    private toaster: ToasterService,
  ) {
    this.server = ErrorNotifyingServer.getServerService();
    this.allQuery = new DatabasesGraphQLResourceQuery();
  }

  public all(): DatabasesGraphQLResourceQuery {
    return this.allQuery;
  }

  public actions(id: string): ng.IPromise<DatabaseAllowedActions> {
    return this.server.sendRequest(new GetDatabaseActionsRequest(id));
  }

  public enableDatabaseControlledPermissions(ids: string[]): ng.IPromise<IEmptyResult> {
    return this.ErrorNotifyingServer.sendRequest(
      new EnableDatabaseControlledPermissionsRequest(ids));
  }

  public disableDatabaseControlledPermissions(ids: string[]): ng.IPromise<IActionResult> {
    return this.ErrorNotifyingServer.sendRequest(
      new DisableDatabaseControlledPermissionsRequest(ids));
  }

  public deleteDatabase = async (id: string, name: string): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new DeleteDatabasesRequest({ids: [id]}))
      .then(r => this.toast(r, Messages.removeExternalContentSuccessful({ ITEM_NAME: name }), Messages.removeFailed()));
  }

  public setDatabaseDescription = async (args: IDatabaseDescriptionParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new SetDatabaseDescriptionRequest(args))
      .then(r => this.toast(r, Messages.editDescriptionSuccessfulWithWait(), Messages.editDescriptionFailure()));
  }

  public setDatabaseCertification = async (args: IDatabaseCertificationParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new SetDatabaseCertificationRequest(args))
      .then(r => this.toast(r, Messages.editCertificationSuccessful(), Messages.editCertificationFailure()));
  }

  public setContact = async (args: IDatabaseContactParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
    .sendRequestAndDelay(new SetDatabasesContactRequest(args));
  }

  private toast(result: IResult, successMessage: string, failureMessage: string): any {
    if (result.errors && result.errors.length > 0) {
      this.toaster.pop({
        type: ToastType.Error,
        text: failureMessage
      });
    } else {
      this.toaster.pop({
        type: ToastType.Info,
        text: successMessage
      });
    }
  }
}

Module.instance().service('Databases', Databases);
